export const clipboard = {
  copyToClipboard: async (text: string) => {
    await navigator.clipboard.writeText(text);
  },
  pasteFromClipboard: async () => {
    return await navigator.clipboard.readText();
  },
};
